export default {
  "widget.defaultTitle": "Chatea con nosotros",
  "widget.defaultSubtitle": "Estamos aquí para ayudarte",
  "widget.defaultGreeting": "¡Hola! ¿Cómo podemos ayudarte hoy?",
  "chat.close": "Cerrar chat",
  "chat.open": "Abrir chat",
  "chat.expand": "Expandir chat",
  "chat.collapse": "Contraer chat",
  "chat.conversationEnded": "Esta conversación ha finalizado",
  "chat.startNew": "Iniciar nueva conversación",
  "chat.poweredBy": "Desarrollado por",
  "chat.conversationClosed": "Conversación cerrada",
  "chat.aiLabel": "Asistente de IA",
  "input.placeholder": "Escribe un mensaje...",
  "input.send": "Enviar mensaje",
  "error.sendFailed": "No se pudo enviar tu mensaje. Inténtalo de nuevo en un momento.",
  "error.messageTooLong": "Tu mensaje es demasiado largo. Acórtalo e inténtalo de nuevo.",
  "chat.teamMember": "Un miembro del equipo",
  "chat.agentJoined": "{name} se ha unido al chat",
  "chat.agentLeft": "{name} ha salido del chat",
  "chat.agentReturnedToAi": "{name} ha salido del chat. Vuelves a hablar con el asistente de IA.",
  "availability.open": "Abierto ahora",
  "availability.backAt": "Volvemos: {when}",
  "availability.closed": "Fuera de horario ahora",
  "waiting.title": "Esperando a una persona",
  "waiting.typical": "Suele responder en {time}",
  "waiting.alerted": "Hemos avisado al equipo.",
  "waiting.closed":
    "El equipo vuelve {when}. Hasta entonces, el asistente de IA puede seguir ayudando.",
  "waiting.minutes": "~{n} min",
  "waiting.hours": "~{n} h",
  "contact.prompt": "Deja tu correo y te enviaremos allí la respuesta del equipo si ya te has ido.",
  "contact.label": "Correo electrónico",
  "contact.placeholder": "tu@ejemplo.com",
  "contact.submit": "Avisarme",
  "contact.consent": "Solo usaremos tu correo para responder a esta conversación.",
  "contact.saved": "¡Gracias! Si ya te has ido cuando el equipo responda, te enviaremos un correo.",
  "contact.failed": "No se pudo guardar tu correo. Revísalo e inténtalo de nuevo.",
  "input.attach": "Adjuntar foto o PDF",
  "error.fileTooLarge": "Ese archivo es demasiado grande. Fotos y PDF de hasta 10 MB.",
  "error.fileType": "Puedes enviar fotos (JPG, PNG, GIF, WebP) o PDF.",
  "error.fileFailed": "No se pudo enviar tu archivo. Prueba con otro.",
  "attachment.photo": "Foto",
  "attachment.file": "Archivo",
  "attachment.sending": "Enviando...",
  "error.verificationFailed": "No pudimos verificar tu mensaje. Actualiza la página e inténtalo de nuevo.",
  "challenge.label": "Verificación de seguridad",
  "challenge.prompt": "Una comprobación rápida de seguridad antes de enviar tu mensaje.",
  "csat.defaultQuestion": "¿Cómo valorarías la atención que recibiste hoy?",
  "csat.thankYou": "¡Gracias por tu opinión!",
} as const;
